import { LOCALES, KEYS } from '../constants';

const esESTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_SPANISH_ES]: {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"Función de partner",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"Integrador",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Proveedor",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"Nivel de partner",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"Especialización del partner",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:" Cisco Powered Service",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"Nombre del partner",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"Ubicación",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"País",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"Palabra clave del nombre del partner",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"Palabras clave del nombre del partner",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"Clasificación",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"Especializaciones",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"Especializaciones de partner",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"Nivel de proveedor y servicios con tecnología de Cisco",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"proveedor Gold",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"proveedor Premier",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"proveedor Select",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"Obtener asesoramiento",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"Solicitar un presupuesto",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"Abrir",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Expandir",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"Contraer",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"Seleccione el país o región",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"Seleccione una función",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Elija especializaciones",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Elija servicios con tecnología de Cisco",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"Elija las experiencias",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"Elija los niveles",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"País o región del partner",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"Niveles de integrador",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"Niveles de proveedor",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"Especializaciones de integradores",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"⁪Servicios con tecnología de Cisco",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"Nombres del partner",
    [KEYS.L18N_KEY_LABEL_BACK ]:"Atrás",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"Todos los resultados",
    [KEYS.L18N_KEY_LABEL_ALL ]:"Todos",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"Guardado",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"Mis partners",
    [KEYS.L18N_KEY_LABEL_ADD ]:"Añadir",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"Eliminar",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"Agregar para comparar ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"Seleccione al menos uno más",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"Comparar seleccionados ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"Eliminar del comparador",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"Comparar",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"Nivel de partner",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"Procesamiento en curso",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"resultado",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"resultados",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"No hay resultados",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"resultado en",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"resultados en",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"No hay resultados en",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"Anterior",
    [KEYS.L18N_KEY_LABEL_PREV ]:"Anterior",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"Siguiente",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"Guardar",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"Conocimientos",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"Descripción general",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"es un Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"Los integradores crean soluciones integrales para nuestros clientes. Realizan principalmente operaciones de reventa, pero aportan su propia experiencia para resolver los problemas empresariales de los clientes",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"Los proveedores son expertos en ofrecer soluciones gestionadas y en la nube. Los clientes buscan una mayor flexibilidad en la forma en que consumen las soluciones y los proveedores son cada vez más importantes en el mercado.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"Búsquedas anteriores",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"Búsqueda anterior",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"Cargos ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"Tecnología",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"Sectores",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"Integradores",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"Proveedores",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"Otro",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"Otros",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"No se han guardado otros partners",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"No hay integradores guardados",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"No hay proveedores guardados",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"filtrar por necesidad",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"buscar por criterios combinados",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"buscar por ubicación",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"Hay 1 partner en todo el mundo",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"Hay",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"partners en todo el mundo",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"No hay partners",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"Hay 1 partner en",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"partners en",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"No hay partners en ",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"Cambiar ubicación",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"Filtrar por necesidad",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"Buscar",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"por nombre, nivel y experiencia",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"seleccionado",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"No se encontraron coincidencias",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"Subir de rango",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"Bajar de rango",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"Subir por nombre",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"Bajar por nombre",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"Se requiere inicio de sesión",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"Debe iniciar sesión para realizar esta acción",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"Error al restaurar la búsqueda",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"Iniciar sesión",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"Se ha guardado el partner correctamente",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"No se ha podido guardar el partner",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"Se ha eliminado el partner correctamente",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"No se pudo eliminar el partner",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"Escriba una palabra clave para buscar por nombre, nivel o experiencia",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"Los desarrolladores son expertos que crean soluciones de software y hardware personalizadas sobre la tecnología de Cisco, lo que da como resultado soluciones únicas que unen los sistemas para ofrecer resultados.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"Los asesores son expertos con un profundo conocimiento del sector que guían a las empresas a medida que exploran soluciones a retos empresariales complejos.",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"Partner diverso",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"Por orden alfabético",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"Mayor experiencia",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"Desarrollador",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"Consejero",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Filtros",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Filtro",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Experiencia de los partners",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Descartar",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Especialización",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Conocimientos",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"No se ha proporcionado ninguna descripción.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"Información",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"Comparador claro",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"Comparación de partners",
    [KEYS.L18N_KEY_LABEL_ROLE]:"Rol",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"Enfoque tecnológico",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"Descripción",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"Seleccionar idioma",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Cerrar sesión",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Partner inclusivo",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Acerca de Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Contáctenos",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Carreras",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Conozca a nuestros socios",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Comentarios",
    [KEYS.L18N_KEY_LABEL_HELP]: "Ayuda",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Términos y condiciones",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Declaración de privacidad",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Marcas",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparencia de la cadena de suministro",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Mapa del sitio",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Acerca de Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Contáctenos",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Carreras",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Conozca a nuestros socios",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Comentarios",
    [KEYS.L18N_KEY_LABEL_HELP]: "Ayuda",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Términos y condiciones",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Declaración de privacidad",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Marcas",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparencia de la cadena de suministro",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Mapa del sitio",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Cómo comprar",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Socios",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Productos y Servicios",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Soluciones",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Soporte",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Aprender",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Explorar Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "Menú",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Cerrar",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Ver más",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Ver menos",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "¿No tienes una cuenta?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "registrarse"
  }
});

export default esESTranslations;
